import axios from 'axios';

export default class CogApiService {
    getRegions() {
        let promise = new Promise((resolve, reject) => {
            axios.get('https://geo.api.gouv.fr/regions?fields=nom,code').then((result) => {
                resolve(result.data);
            });

            return promise;
        });
    }

    async getRegByDep(dep) {
        let result = await axios.get(`https://geo.api.gouv.fr/departements/${dep}?fields=codeRegion`);
        return result.data;
    }

    async getDepByRegions(reg) {
        let result = await axios.get(`https://geo.api.gouv.fr/regions/${reg}/departements?fields=nom,code`);
        return result.data;
    }

    async getComByDep(dep) {
        let result = await axios.get(`https://geo.api.gouv.fr/departements/${dep}/communes?fields=nom,code`);
    }

    async getEpciByCom(com) {
        let result = await axios.get(`https://geo.api.gouv.fr/communes/${com}?fields=nom,code,codeEpci,codeDepartement,codeRegion`);
        return result.data;
    }

    async getComByEpci(epci) {
        let result = await axios.get(`https://geo.api.gouv.fr/communes/${com}/epci?fields=nom,code`);
        return result.data;
    }

    getArrondissments($code) {
        switch ($code) {
            case '13055':
                return [
                    { code: '13201', nom: 'Marseille 1er Arrondissement' },
                    { code: '13202', nom: 'Marseille 2e Arrondissement' },
                    { code: '13203', nom: 'Marseille 3e Arrondissement' },
                    { code: '13204', nom: 'Marseille 4e Arrondissement' },
                    { code: '13205', nom: 'Marseille 5e Arrondissement' },
                    { code: '13206', nom: 'Marseille 6e Arrondissement' },
                    { code: '13207', nom: 'Marseille 7e Arrondissement' },
                    { code: '13208', nom: 'Marseille 8e Arrondissement' },
                    { code: '13209', nom: 'Marseille 9e Arrondissement' },
                    { code: '13210', nom: 'Marseille 10e Arrondissement' },
                    { code: '13211', nom: 'Marseille 11e Arrondissement' },
                    { code: '13212', nom: 'Marseille 12e Arrondissement' },
                    { code: '13213', nom: 'Marseille 13e Arrondissement' },
                    { code: '13214', nom: 'Marseille 14e Arrondissement' },
                    { code: '13215', nom: 'Marseille 15e Arrondissement' },
                    { code: '13216', nom: 'Marseille 16e Arrondissement' },
                ];

            case '69123':
                return [
                    { code: '69381', nom: 'Lyon 1er Arrondissement' },
                    { code: '69382', nom: 'Lyon 2e Arrondissement' },
                    { code: '69383', nom: 'Lyon 3e Arrondissement' },
                    { code: '69384', nom: 'Lyon 4e Arrondissement' },
                    { code: '69385', nom: 'Lyon 5e Arrondissement' },
                    { code: '69386', nom: 'Lyon 6e Arrondissement' },
                    { code: '69387', nom: 'Lyon 7e Arrondissement' },
                    { code: '69388', nom: 'Lyon 8e Arrondissement' },
                    { code: '69389', nom: 'Lyon 9e Arrondissement' },
                ];
            case '75056':
                return [
                    { code: '75101', nom: 'Paris 1er Arrondissement' },
                    { code: '75102', nom: 'Paris 2e Arrondissement' },
                    { code: '75103', nom: 'Paris 3e Arrondissement' },
                    { code: '75104', nom: 'Paris 4e Arrondissement' },
                    { code: '75105', nom: 'Paris 5e Arrondissement' },
                    { code: '75106', nom: 'Paris 6e Arrondissement' },
                    { code: '75107', nom: 'Paris 7e Arrondissement' },
                    { code: '75108', nom: 'Paris 8e Arrondissement' },
                    { code: '75109', nom: 'Paris 9e Arrondissement' },
                    { code: '75110', nom: 'Paris 10e Arrondissement' },
                    { code: '75111', nom: 'Paris 11e Arrondissement' },
                    { code: '75112', nom: 'Paris 12e Arrondissement' },
                    { code: '75113', nom: 'Paris 13e Arrondissement' },
                    { code: '75114', nom: 'Paris 14e Arrondissement' },
                    { code: '75115', nom: 'Paris 15e Arrondissement' },
                    { code: '75116', nom: 'Paris 16e Arrondissement' },
                    { code: '75117', nom: 'Paris 17e Arrondissement' },
                    { code: '75118', nom: 'Paris 18e Arrondissement' },
                    { code: '75119', nom: 'Paris 19e Arrondissement' },
                    { code: '75120', nom: 'Paris 20e Arrondissement' },
                ];
        }
    }
}
